import React from "react";
import bg from "../../../assets/v2/atlantis_logo.svg"


export const About = (props) => {
  return (
    <div id="about" style={{
        maxWidth: "100%",
        overflow: "hidden",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center"
    }}>
      <div className="container">
        <div className="row">
          <div
              className="col-xs-12 col-md-6"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%", // Assicurati che il genitore abbia altezza definita
              }}
          >
            <img
                src={bg}
                alt=""
                style={{
                  background: "#f9f9f9",
                  width: "80%",
                }}
            />
          </div>


          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>Su di noi</h2>
              <p>{props.data ? props.data.paragraph : "loading..."}</p>
              <h3>Perchè scegliere noi</h3>
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why.map((d, i) => (
                          <li key={`${d}-${i}`}>{d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why2.map((d, i) => (
                          <li key={`${d}-${i}`}> {d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
